
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'wms-view-only-notice'
});
